var map = {
	"./images/avatars/user.png": "VqNk",
	"./images/bank_0001.png": "daRE",
	"./images/bank_0033.png": "lf7n",
	"./images/bank_0041.png": "ozAO",
	"./images/bank_0102.png": "GQOU",
	"./images/bank_0104.png": "BmIa",
	"./images/bank_0237.png": "rWbf",
	"./images/bank_0341.png": "0yRu",
	"./images/bank_0422.png": "sW/z",
	"./images/bank_0745.png": "1acf",
	"./images/bank_0748.png": "2pNv",
	"./images/bank_default.png": "qNBk",
	"./images/bb-55x55.png": "WD6S",
	"./images/bradesco-55x55.png": "yhI5",
	"./images/flags/flag-au.png": "rtCR",
	"./images/flags/flag-jp.png": "s0rv",
	"./images/flags/flag-uk.png": "gXrL",
	"./images/flags/flag-us.png": "CXWe",
	"./images/logos/logo-h-small.png": "YD86",
	"./images/logos/logo-s.png": "5DBO",
	"./images/santander-55x55.png": "zYAq",
	"./images/sicredi-55x55.png": "iqAg",
	"./images/user-profile/team-thumb-1.png": "JgXi",
	"./images/user-profile/team-thumb-2.png": "7tqp",
	"./images/user-profile/team-thumb-3.png": "QEv4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32Qh";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.png$
// module id = 32Qh
// module chunks = 3